/* Extracted from snippets/search-bottom-sheet.liquid - pure JS,
   no Liquid interpolation. External + defer to cut HTML payload
   and let the browser cache across pages. */
(function() {
  'use strict';
  var root = document.getElementById('SearchSheet');
  if (!root) return;
  // Restore default cards on intent.
  var template = root.querySelector('[data-ss-template]');
  if (template) template.replaceWith(template.content);

  /* Refs */
  var panel   = root.querySelector('.ss__panel');
  var input   = root.querySelector('[data-ss-input]');
  var clearBtn= root.querySelector('[data-ss-clear]');
  var body    = root.querySelector('[data-ss-body]');
  var defaultEl = root.querySelector('[data-ss-default]');
  var resultsEl = root.querySelector('[data-ss-results]');
  var emptyEl = root.querySelector('[data-ss-empty]');
  var emptyTextEl = emptyEl.querySelector('p');
  var retryBtn = root.querySelector('[data-ss-retry]');
  var form    = root.querySelector('[data-ss-form]');
  var handle  = root.querySelector('[data-ss-handle]');
  var statusEl= root.querySelector('[data-ss-status]');

  var cache = {};
  var ac = null;       /* AbortController */
  var debounce = null;
  var isOpen = false;
  var activeRequestId = 0;
  var activeOptionIndex = -1;
  var returnFocusTo = null;

  /* --------- State machine --------- */
  /* Animating `height: auto` requires an explicit from→to pixel range -
     CSS transition can't interpolate from `auto`. Pattern:
       1. Lock panel to current pixel height
       2. Swap state (.ss__default ↔ .ss__results display)
       3. Briefly clear height to measure new content's natural size
       4. Re-lock to OLD size, force a layout flush
       5. On next frame set NEW size → CSS transition runs from old → new
       6. After transition, clear inline height so future content changes
          (longer results, etc.) flow via height:auto naturally
  */
  var stateAnimRAF = null;
  var stateAnimClear = null;
  function setState(s) {
    input.setAttribute('aria-expanded', s === 'results' ? 'true' : 'false');
    if (!isOpen || body.getAttribute('data-state') === s) {
      body.setAttribute('data-state', s);
      return;
    }
    /* If a previous transition is still running, cancel it */
    if (stateAnimRAF) { cancelAnimationFrame(stateAnimRAF); stateAnimRAF = null; }
    if (stateAnimClear) { panel.removeEventListener('transitionend', stateAnimClear); stateAnimClear = null; }

    var fromH = panel.offsetHeight;
    /* Lock current height */
    panel.style.height = fromH + 'px';
    /* Swap content */
    body.setAttribute('data-state', s);
    /* Measure new target (briefly clear lock to let auto resolve) */
    panel.style.height = '';
    var toH = panel.offsetHeight;
    if (fromH === toH) return;
    /* Re-lock to from-height immediately so visual position is unchanged */
    panel.style.height = fromH + 'px';
    /* Double rAF: wait for browser to actually paint at fromH before
       setting toH. Single rAF / void offsetHeight isn't enough - browsers
       batch identical-frame style mutations and skip the from→to
       transition. Two rAFs guarantee a paint between the locks. */
    stateAnimRAF = requestAnimationFrame(function () {
      stateAnimRAF = requestAnimationFrame(function () {
        stateAnimRAF = null;
        panel.style.height = toH + 'px';
        stateAnimClear = function (e) {
          if (e && e.target !== panel) return;
          if (e && e.propertyName !== 'height') return;
          panel.removeEventListener('transitionend', stateAnimClear);
          stateAnimClear = null;
          panel.style.height = '';
        };
        panel.addEventListener('transitionend', stateAnimClear);
        setTimeout(function () { if (stateAnimClear) stateAnimClear(); }, 500);
      });
    });
  }
  setState('default');

  // A tablet rotation must not leave an invisible mobile dialog active.
  window.matchMedia('(min-width: 768px)').addEventListener('change', function(e) {
    if (e.matches) close();
  });

  var scrollY = 0;
  var ssScrollLockId = null;

  function lockScroll() {
    scrollY = window.scrollY || window.pageYOffset || 0;
    if (ssScrollLockId !== null || !window.themeSheetScrollLock) return;
    // The shared lock handles touch + wheel, nested vertical scrollers,
    // horizontal product/category lanes, and both scroll boundaries.
    ssScrollLockId = window.themeSheetScrollLock.lock(function () {
      return root.classList.contains('is-open') ? panel : null;
    });
  }
  function unlockScroll() {
    if (ssScrollLockId === null || !window.themeSheetScrollLock) return;
    window.themeSheetScrollLock.unlock(ssScrollLockId);
    ssScrollLockId = null;
  }

  /* --------- Visible viewport sync ---------
     Keep preferred sizes from before focus, but fit the shell to the visible
     viewport. iOS WebViews pan as well as shrink it when the keyboard opens. */
  function captureOpenViewport() {
    var vv = window.visualViewport;
    var openLayoutHeight = Math.max(
      window.innerHeight || 0,
      document.documentElement.clientHeight || 0,
      vv ? vv.height : 0
    );
    root.style.setProperty('--ss-default-min-h', Math.round(openLayoutHeight * 0.35) + 'px');
    root.style.setProperty('--ss-results-min-h', Math.round(openLayoutHeight * 0.8) + 'px');
  }

  function syncViewport() {
    if (!isOpen) return;
    var vv = window.visualViewport;
    var height = vv ? vv.height : window.innerHeight;
    if (!height) return;
    // A fixed shell needs the visible viewport's layout-relative offset, too.
    root.style.setProperty('--ss-vv-top', Math.max(0, vv ? vv.offsetTop : 0) + 'px');
    root.style.setProperty('--ss-vv-h', height + 'px');
  }
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', syncViewport);
    window.visualViewport.addEventListener('scroll', syncViewport);
  }
  window.addEventListener('resize', syncViewport);

  /* --------- Open / Close --------- */
  function open(opener) {
    if (isOpen) return;
    isOpen = true;
    returnFocusTo = opener && typeof opener.focus === 'function' ? opener : document.activeElement;
    // The shared overlay controller may load after the input was focused.
    // Give it the real opener instead of letting it capture the sheet input.
    root.__searchReturnFocusElement = returnFocusTo;
    captureOpenViewport();
    syncViewport();
    root.classList.remove('is-closing');
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    lockScroll();
    setState('default');
    input.value = root.dataset.initialQuery || '';
    clearBtn.classList.toggle('is-visible', input.value.length > 0);
    resultsEl.innerHTML = '';
    if (input.value.trim()) fetchResults(input.value.trim());
    /* Focus input after slide-up animation completes (iOS keyboard opens) */
    setTimeout(function() {
      if (!isOpen) return;
      input.focus({ preventScroll: true });
      /* Include late keyboard geometry updates in embedded iOS browsers. */
      setTimeout(syncViewport, 150);
      setTimeout(syncViewport, 400);
    }, 360);
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    activeRequestId += 1;
    clearTimeout(debounce);

    /* RACE FIX: do the visual close FIRST, defer JS teardown.
       Previously input.blur() + ac.abort() + style clears ran
       synchronously BEFORE adding is-closing - each can fire a
       cascade of listeners (predictive-search teardown, focusout
       handlers, fetch reject paths) that pin the main thread for
       50-300 ms. Result: the user taps close and sees nothing
       happen for that delay before the panel finally starts to
       slide. By swapping the class first, the browser kicks off
       the compositor-driven transform animation on the next frame
       regardless of how busy the JS thread is. */
    /* Swap classes IMMEDIATELY - keep any inline transform from a
       swipe gesture in place so the transition animates from the
       drag-in-progress position to the closed position smoothly,
       no snap-back. The browser handles the transition without a
       forced reflow. */
    var backdropEl = root.querySelector('.ss__backdrop');
    panel.style.transition = '';
    backdropEl.style.transition = '';
    root.classList.add('is-closing');
    root.classList.remove('is-open');
    /* Clear the inline transform/opacity AFTER the class swap so
       the is-closing rule is what wins in the computed style.
       Doing this in a microtask lets the class change paint first. */
    Promise.resolve().then(function () {
      panel.style.transform = '';
      backdropEl.style.opacity = '';
    });

    /* Heavy teardown deferred - runs after the next frame so the
       slide animation has started painting. */
    setTimeout(function () {
      input.blur();
      if (ac) { ac.abort(); ac = null; }
      clearTimeout(debounce);
    }, 0);
    // Single finalize() invocation guarded by a `done` flag so the transitionend listener and the 420ms safety timeout can't both run.
    var done = false;
    function finalize() {
      if (done) return;
      done = true;
      panel.removeEventListener('transitionend', onEnd);
      if (safetyT) { clearTimeout(safetyT); safetyT = null; }
      root.classList.remove('is-closing');
      root.setAttribute('aria-hidden', 'true');
      root.style.removeProperty('--ss-vv-top');
      root.style.removeProperty('--ss-vv-h');
      root.style.removeProperty('--ss-default-min-h');
      root.style.removeProperty('--ss-results-min-h');
      unlockScroll();
      var focusTarget = returnFocusTo;
      returnFocusTo = null;
      requestAnimationFrame(function() {
        if (!isOpen && focusTarget && focusTarget.isConnected) {
          focusTarget.focus({ preventScroll: true });
        }
      });
    }
    var onEnd = function (e) {
      // Only react to the panel's own transitionend (not bubbled from descendants).
      if (e && e.target !== panel) return;
      if (e && e.propertyName !== 'transform') return;
      finalize();
    };
    panel.addEventListener('transitionend', onEnd);
    /* Safety fallback paired with the 240ms close transition in
       component-search-bottom-sheet.css - keep a small headroom over
       the CSS duration in case Safari fails to fire transitionend. */
    var safetyT = setTimeout(finalize, 300);
  }

  /* --------- Close triggers --------- */
  root.querySelectorAll('[data-ss-close]').forEach(function(el) {
    el.addEventListener('click', close);
  });
  root.addEventListener('keydown', function(e) {
    if (e.isComposing || e.keyCode === 229) return;
    if (e.key === 'Tab' && isOpen) {
      if (e.defaultPrevented) return; // Shared overlay trap already handled this key.
      // Recompute after each result update; cached first/last nodes become
      // detached when a query replaces the result markup.
      var focusable = Array.prototype.slice.call(panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex="0"]'
      )).filter(function(el) {
        return el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && el.tabIndex >= 0;
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && e.target === first || !e.shiftKey && e.target === last) {
        e.preventDefault();
        e.stopPropagation();
        (e.shiftKey ? last : first).focus();
      }
      return;
    }
    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    var options = Array.prototype.slice.call(
      resultsEl.querySelectorAll('[role="option"]')
    ).filter(function(option) { return option.offsetParent !== null; });
    if (!options.length) return;
    if (e.key === 'Enter') {
      if (activeOptionIndex < 0) return;
      e.preventDefault();
      var target = options[activeOptionIndex].matches('a,button')
        ? options[activeOptionIndex]
        : options[activeOptionIndex].querySelector('a,button');
      if (target) target.click();
      return;
    }
    e.preventDefault();
    options.forEach(function(option) { option.setAttribute('aria-selected', 'false'); });
    activeOptionIndex = e.key === 'ArrowDown'
      ? (activeOptionIndex + 1) % options.length
      : (activeOptionIndex <= 0 ? options.length - 1 : activeOptionIndex - 1);
    var active = options[activeOptionIndex];
    if (!active.id) active.id = 'search-sheet-option-' + (activeOptionIndex + 1);
    active.setAttribute('aria-selected', 'true');
    input.setAttribute('aria-activedescendant', active.id);
    active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });

  /* --------- Clear --------- */
  clearBtn.addEventListener('click', function() {
    clearTimeout(debounce);
    activeRequestId += 1;
    if (ac) { ac.abort(); ac = null; }
    input.value = '';
    input.focus();
    clearBtn.classList.remove('is-visible');
    setState('default');
    resultsEl.innerHTML = '';
    activeOptionIndex = -1;
    input.removeAttribute('aria-activedescendant');
    statusEl.textContent = '';
  });

  /* --------- Quick tag click --------- */
  root.querySelectorAll('[data-ss-tag]').forEach(function(tag) {
    tag.addEventListener('click', function(e) {
      e.preventDefault();
      var q = this.getAttribute('data-ss-tag');
      input.value = q;
      clearBtn.classList.add('is-visible');
      fetchResults(q);
    });
  });

  /* --------- Input handling --------- */
  input.addEventListener('input', function() {
    var q = input.value.trim();
    clearBtn.classList.toggle('is-visible', q.length > 0);
    clearTimeout(debounce);
    activeOptionIndex = -1;
    input.removeAttribute('aria-activedescendant');
    if (!q) {
      activeRequestId += 1;
      if (ac) { ac.abort(); ac = null; }
      setState('default');
      resultsEl.innerHTML = '';
      statusEl.textContent = '';
      return;
    }
    debounce = setTimeout(function() { fetchResults(q); }, 280);
  });

  /* Submit form */
  form.addEventListener('submit', function(e) {
    var q = input.value.trim();
    if (!q) { e.preventDefault(); return; }
    /* Let the form navigate to /search?q=... */
    close();
  });

  /* Predictive-search HTML is fetched as a standalone section and injected
     into `resultsEl`, which lives outside the search form. The theme's
     "Search for …" control is a submit button, so without an associated form
     it is inert. Delegate from the stable results container because this
     button is replaced on every query, and submit the real sheet form. */
  resultsEl.addEventListener('click', function(e) {
    var searchForControl = e.target.closest(
      '.predictive-search__search-for-button, .predictive-search__item--term'
    );
    if (!searchForControl || !resultsEl.contains(searchForControl)) return;

    e.preventDefault();
    if (!input.value.trim()) return;

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      close();
      form.submit();
    }
  });

  /* --------- Predictive search API --------- */
  var loadingEl = root.querySelector('[data-ss-loading]');

  function fetchResults(q) {
    // A clear/close can happen before the debounce fires. Never start work
    // for an input that is no longer visible or no longer contains this query.
    if (!isOpen || input.value.trim() !== q) return;
    if (ac) { ac.abort(); ac = null; }
    var requestId = ++activeRequestId;
    var url = window.StorefrontSearch.predictiveUrl(q);
    var fullSearch = root.querySelector('[data-ss-full-search]');
    fullSearch.href = window.StorefrontSearch.searchUrl(q);
    fullSearch.textContent = window.storefrontSearchConfig.searchFor.replace('__TERMS__', q);
    var contextKey = function() {
      return JSON.stringify([window.Shopify?.country || '', window.Shopify?.currency?.active || '', document.documentElement?.lang || '']);
    };
    var marketContext = contextKey();
    var key = url + marketContext;
    var isCurrent = function() {
      return isOpen && requestId === activeRequestId && input.value.trim() === q && marketContext === contextKey();
    };
    if (!window.StorefrontSearch.predictiveSupported()) {
      setState('empty');
      emptyTextEl.textContent = window.storefrontSearchConfig.unavailable;
      retryBtn.hidden = true;
      loadingEl.setAttribute('aria-hidden', 'true');
      statusEl.textContent = emptyTextEl.textContent;
      return;
    }
    if (cache[key]) { renderResults(cache[key], q); return; }

    ac = new AbortController();
    setState('loading');
    loadingEl.setAttribute('aria-hidden', 'false');
    statusEl.textContent = root.dataset.loadingText || 'Loading';

    fetch(url, { signal: ac.signal })
      .then(function(r) {
        if (!r.ok) { var error = new Error('Predictive search request failed: ' + r.status); error.status = r.status; throw error; }
        return r.text();
      })
      .then(function(html) {
        if (!isCurrent()) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var section = doc.querySelector('#shopify-section-predictive-search');
        var resultRoot = section
          ? section.querySelector('#predictive-search-results')
          : doc.querySelector('#predictive-search-results');
        if (!resultRoot) throw new Error('Predictive search section is missing');
        var termNode = resultRoot.querySelector('[data-predictive-search-search-for-text]');
        if (termNode && root.dataset.searchForText) {
          termNode.textContent = root.dataset.searchForText.replace('__TERMS__', q);
        }
        var markup = resultRoot ? resultRoot.outerHTML : '';
        // A successful empty result still has a result root. Missing sections
        // are errors and must remain retryable, never cached as no matches.
        var keys = Object.keys(cache);
        if (keys.length >= 20) delete cache[keys[0]];
        cache[key] = markup;
        renderResults(markup, q);
      })
      .catch(function(err) {
        if (err.name === 'AbortError') return;
        if (!isCurrent()) return;
        loadingEl.setAttribute('aria-hidden', 'true');
        setState('empty');
        emptyTextEl.textContent = err.status === 417 ? window.storefrontSearchConfig.unavailable : root.dataset.errorText;
        retryBtn.hidden = err.status === 417;
        statusEl.textContent = emptyTextEl.textContent;
      });
  }

  retryBtn.addEventListener('click', function() {
    var q = input.value.trim();
    if (!q) {
      setState('default');
      input.focus();
      return;
    }
    retryBtn.hidden = true;
    fetchResults(q);
  });

  function renderResults(markup, q) {
    var staleRecovery = emptyEl.querySelector('.search-recovery');
    if (staleRecovery) staleRecovery.remove();
    retryBtn.hidden = true;
    if (!markup || !markup.trim()) {
      loadingEl.setAttribute('aria-hidden', 'true');
      setState('empty');
      var noResults = (root.dataset.noResultsText || 'No results for “__TERMS__”').replace('__TERMS__', q);
      emptyTextEl.textContent = noResults;
      statusEl.textContent = noResults;
      return;
    }
    resultsEl.innerHTML = markup;
    if (window.localizePredictiveSearch) window.localizePredictiveSearch(resultsEl);
    var productResults = resultsEl.querySelector('.search_result-products');
    var articleResults = resultsEl.querySelector('.predictive-search__article-wrapper');
    var resultRightColumn = resultsEl.querySelector('.searchbar-right.wbsrightpart');
    if (productResults && articleResults && resultRightColumn) {
      resultRightColumn.appendChild(articleResults);
    }
    if (resultsEl.querySelector('.predictive-search__empty')) {
      var recoveryPanel = resultsEl.querySelector(':scope > .search-recovery');
      if (recoveryPanel) emptyEl.insertBefore(recoveryPanel, emptyEl.firstChild);
      resultsEl.innerHTML = '';
      loadingEl.setAttribute('aria-hidden', 'true');
      setState('empty');
      var emptyText = (root.dataset.noResultsText || 'No results for “__TERMS__”').replace('__TERMS__', q);
      emptyTextEl.textContent = emptyText;
      statusEl.textContent = emptyText;
      return;
    }
    loadingEl.setAttribute('aria-hidden', 'true');
    activeOptionIndex = -1;
    var countEl = resultsEl.querySelector('[data-predictive-search-live-region-count-value]');
    statusEl.textContent = countEl ? countEl.textContent.trim() : '';
    setState('results');
    window.AlAsilDiscovery?.emit('search_suggest_viewed', { search_term: q, suggestions_count: resultsEl.querySelectorAll('[role="option"]:not(.predictive-search__item--term)').length });
  }

  /* --------- Native-feel swipe to close ---------
     Dismissal starts only from the visible handle. Content gestures always
     belong to result scrolling, even when the result body is at scrollTop 0. */
  var swipe = {
    active: false, dragging: false, startY: 0, lastY: 0, lastT: 0, velocity: 0, distance: 0
  };
  var backdrop = root.querySelector('.ss__backdrop');

  function onSwipeStart(e) {
    if (!isOpen) return;
    if (!e.target.closest('.ss__handle')) return;
    if (!e.touches || !e.touches.length) return;

    swipe.active = true;
    swipe.dragging = false;
    swipe.startY = swipe.lastY = e.touches[0].clientY;
    swipe.lastT = Date.now();
    swipe.velocity = 0;
    swipe.distance = 0;
    panel.style.transition = 'none';
    backdrop.style.transition = 'none';
  }

  function onSwipeMove(e) {
    if (!swipe.active) return;
    var y = e.touches[0].clientY;
    var now = Date.now();
    var dt = now - swipe.lastT;
    if (dt > 0) swipe.velocity = (y - swipe.lastY) / dt; /* px per ms */
    swipe.lastY = y;
    swipe.lastT = now;
    swipe.distance = y - swipe.startY;

    /* Ignore tap jitter and upward movement; the panel should not move until
       the gesture clearly communicates a downward dismiss intent. */
    if (swipe.distance <= 0) return;
    if (!swipe.dragging && swipe.distance < 12) return;
    swipe.dragging = true;

    var resisted = swipe.distance - 12;
    panel.style.transform = 'translateY(' + resisted + 'px)';
    backdrop.style.opacity = String(Math.max(0, 1 - resisted / 500));
  }

  function onSwipeEnd() {
    if (!swipe.active) return;
    var wasDragging = swipe.dragging;
    swipe.active = false;
    swipe.dragging = false;
    panel.style.transition = '';
    backdrop.style.transition = '';

    /* A fast flick still needs real travel. Tiny high-velocity movements are
       common when a finger leaves a scrolling surface and must not dismiss. */
    var distanceThreshold = Math.min(160, panel.offsetHeight * 0.22);
    var shouldClose = wasDragging
      && swipe.distance >= 48
      && (swipe.velocity > 0.65 || swipe.distance > distanceThreshold);
    if (shouldClose) {
      close();
    } else {
      /* Snap back with spring */
      panel.style.transform = '';
      backdrop.style.opacity = '';
    }
  }

  function onSwipeCancel() {
    if (!swipe.active) return;
    swipe.active = false;
    swipe.dragging = false;
    panel.style.transition = '';
    backdrop.style.transition = '';
    panel.style.transform = '';
    backdrop.style.opacity = '';
  }

  panel.addEventListener('touchstart', onSwipeStart, { passive: true });
  panel.addEventListener('touchmove', onSwipeMove, { passive: true });
  panel.addEventListener('touchend', onSwipeEnd);
  panel.addEventListener('touchcancel', onSwipeCancel);

  /* --------- Expose API --------- */
  window.searchSheet = { open: open, close: close };

  /* --------- Intercept header search on mobile --------- */
  var headerSel = '.header__search, [class*="header__icon--search"], details-modal.header__search, .middle-search-bar, #Search-In-Modal';

  /* Capture-phase click: runs before details-modal's handler */
  document.addEventListener('click', function(e) {
    if (window.innerWidth >= 768) return;
    if (!e.target.closest(headerSel)) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    /* Close header details-modal if it opened */
    var details = document.querySelector('.header__search details[open]');
    if (details) details.removeAttribute('open');
    document.body.classList.remove('overflow-hidden');
    open();
  }, true);

  /* Blur input if it gets focus (prevents keyboard from opening behind the sheet) */
  document.addEventListener('focusin', function(e) {
    if (window.innerWidth >= 768) return;
    if (!e.target.matches('.header__search input[type="search"], #Search-In-Modal')) return;
    e.target.blur();
    if (!isOpen) open();
  }, true);
})();
